export default __webpack_public_path__ + "static/headerBg-f605c6b43baa1948e2316ecc68f30b63.png";